<template>
  <div
    class="date-field-wrapper"
    :class="opened ? 'calendar-opened' : ''"
  >
    <slot v-bind="bindings" />
    <range-calendar
      v-if="opened"
      v-model="date"
      :calendar-start-date="calendarStartDate"
      :calendar-end-date="calendarEndDate"
      :available-dates="availableDates"
      :lang="lang"
      :outer-activator="target"
      @close="opened = false"
      @reset-calendar="resetCalendarDate"
    />
  </div>
</template>

<script>
  import { formatDateZone } from '@utils/date-helpers'
  import RangeCalendar from './range-calendar/range-calendar.vue'

  export default {
    name: 'DateRangeFieldInput',
    components: {
      RangeCalendar
    },
    props: {
      lang: {
        type: Object,
        default: () => ({})
      },
      availableDates: {
        type: Array,
        default: () => ([])
      }
    },
    data: () => ({
      date: null,
      resultLabel: null,
      opened: false,
      target: null,
      calendarStartDate: new Date().toISOString(),
      calendarEndDate: null,
    }),
    computed: {
      bindings() {
        return {
          toggleCalendar: this.toggleCalendar,
          resultLabel: this.resultLabel
        }
      },
    },
    watch: {
      date(val) {
        if (val && Object.keys(val).length !== 0) {
          this.toggleCalendar(false)
        }
        this.fieldResultLabel(val)
        this.$emit('date-change', val)
      },
      opened(val) {
        if (!val) {
          this.target = null
        }
      }
    },
    mounted() {
      const input = this.$el.querySelector('input')
      const calendarStartDate = input.getAttribute('min')
      const calendarEndDate = input.getAttribute('max')

      if (calendarStartDate) {
        this.calendarStartDate = new Date(calendarStartDate).toISOString()
      }
      if (calendarEndDate) {
        this.calendarEndDate = new Date(calendarEndDate).toISOString()
      }
    },
    created() {
      this.$root.$on('reset-date-field', this.resetDateValue)
    },
    methods: {
      resetCalendarDate() {
        this.date = {}
      },
      toggleCalendar(val) {
        const haveVal = typeof val === 'boolean'
        if (typeof val === 'object' && 'target' in val) {
          this.target = val.target
        }
        this.opened = haveVal ? val : !this.opened
      },
      fieldResultLabel(dates) {
        if (dates && Object.keys(dates).length !== 0) {
          const formatedStartDate = formatDateZone(dates?.selectedStartDate, null, 'DD MMM. YYYY')
          const formatedEndDate = formatDateZone(dates?.selectedEndDate, null, 'DD MMM. YYYY')
          if (formatedStartDate === formatedEndDate) {
            this.resultLabel = `${formatedStartDate}`
            return
          }
          this.resultLabel = `${formatedStartDate} - ${formatedEndDate}`
        } else {
          this.resultLabel = ''
        }
      },
    }
  }
</script>

